<template>
  <div>
    <list
      :hidePageInfo="true"
      v-if="model"
      :columns="model.columns"
      :modalCreate="model.modalCreate"
      :removeLink="model.removeLink"
      :cardLink="u"
      :isUpdate="model.isUpdate"
      :params="p"
      :isAdd="model.isAdd"
      :itemLink="u"
      :setLink="u"
      :openItem="model.openItem"
      :fields="model.fields"
      :searchDisable="model.searchDisable"
      v-model="val"
      :simple="simple"
      @input="accept"
    />
  </div>
</template>
<script>
import List from "../List";

export default {
  name: "ListItem",
  data() {
    return {
      val: [],
      p: {},
      u: "",
    };
  },
  props: {
    modal: {
      default: function () {
        return "";
      },
    },
    url: {
      default: function () {
        return "";
      },
    },
    params: {
      default: function () {
        return null;
      },
    },
    prefix: {
      default: function () {
        return "";
      },
    },
    simple: {
      default: false,
    },
    triggerOpen: {
      default: false,
    },
    value: {
      default: function () {
        return [];
      },
    },
  },
  computed: {
    model: {
      get() {
        return this.$store.state.modals[this.modal];
      },
    },
  },
  created() {
    this.val = this.value;
    this.p = this.model.params ? this.model.params : this.params;

    this.u = this.url ? this.url : this.model["itemLink"];
  },
  watch: {
    value(val) {
      this.val = val;
    },
  },
  components: {
    List,
  },
  methods: {
    openInfo(id) {
      let query = Object.assign({}, this.$route.query);
      if (query["item_info_project_info"] == id) {
        return false;
      }

      if (query["item_info_project_info"]) {
        delete query["item_info_project_info"];
      }

      query["item_info_project_info"] = id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
    modalClose() {},
    modalOpen() {},
    closeModal() {
      if (this.triggerOpen === true) {
        this.$notify({
          title: "Установите элемент",
          message: "Требуется сделать выбор элемента из списка",
          icon: "ti-save",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
        return false;
      }

      this.$modal.hide(`${this.modal}${this.prefix}`);
    },
    accept() {
      if (this.val) {
        this.$emit("input", this.val);

        try {
          if (this.val[0] && this.val[0].id && this.modal === "info_project") {
            let info_project = this.val[0];
            if (info_project.errors_count > 0) {
              this.openInfo(info_project.id);
            }
          }
        } catch (error) {}

        this.val = [];
      }
    },
  },
};
</script>

